import { getProductNameFromUrl } from 'utils/routing/routeHelpers'

/**
 * Creates a back-click handler for UnitV3. For now it routes back to the
 * DWB lessons landing; future grade-band aware behavior should mirror the
 * TieredInterventionsUnits helper once DWB course slugs are finalized.
 */
export const handleBackClick = ({ location, navigationEvent }) => {
  return function onBackClick() {
    const search = location?.search || ''
    const destination = search
      ? `/product/digital-well-being/lessons${
          search.startsWith('?') ? search : `?${search}`
        }`
      : '/product/digital-well-being/lessons'

    navigationEvent(destination)
  }
}

/**
 * Factory for the unit-tab change handler. Mirrors TieredInterventionsUnits
 * so that downstream code can swap the page in without rewiring callers.
 */
export const handleTabChange = ({ location, navigationEvent }) => {
  return function onTabChange(tab) {
    const { search } = location || {}
    const destination = `${tab?.route}?${new URLSearchParams(
      search,
    )?.toString()}`
    navigationEvent(destination)
  }
}

export const getPathForRoute = ({
  routeValue,
  matchUrl,
  queryParamsString,
}) => {
  if (!routeValue || typeof routeValue !== 'string') return ''
  if (routeValue.startsWith('/')) return `${routeValue}${queryParamsString}`
  return `${matchUrl}/${routeValue}${queryParamsString}`
}

export const getTrainingPathForRoute = ({
  routeValue,
  matchUrl,
  productName,
  queryParamsString,
}) => {
  if (!routeValue || typeof routeValue !== 'string') return ''
  const resolvedProductName = productName || getProductNameFromUrl(matchUrl)

  if (routeValue.startsWith('/product/')) {
    return `${routeValue}${queryParamsString}`
  }

  if (routeValue.startsWith('/training/')) {
    if (!resolvedProductName) {
      return `${routeValue}${queryParamsString}`
    }
    return `/product/${resolvedProductName}${routeValue}${queryParamsString}`
  }

  if (routeValue.startsWith('/')) return `${routeValue}${queryParamsString}`

  if (!resolvedProductName) {
    return getPathForRoute({ routeValue, matchUrl, queryParamsString })
  }

  return `/product/${resolvedProductName}/training/${routeValue}${queryParamsString}`
}
